import React, { useEffect, useRef, useState } from 'react';
import styles from './Toggle.module.scss';
import ReactTooltip from 'react-tooltip';

import Tooltip from "../Tooltip/Tooltip";
import { $t } from "../../../helpers/translator";

const Toggle = (props) => {
    const [ status, setStatus ] = useState(false);

    useEffect(() => {
        // console.log('status received:', props.status)
        setStatus(props.status);
    }, [ props.status ]);

    function toggle() {
        if (props.disabled) return

        props.onChange(!status)
        setStatus(!status)
    }

    return (
        <div className={ [ styles.container, props.disabled && styles.disabled ].join(' ') }>
            <div className={ styles.off }>
                { props.offText }
            </div>
            <div className={ `${styles.grayContainer}` } onClick={ () => toggle() }>
                <div className={ `${styles.toggleButton}  ${(status ? styles.alignRight : styles.alignLeft)}` } />
            </div>
            <div className={ styles.on }>
                { props.onText }
            </div>
        </div>
    );
}

Toggle.defaultProps = {
    onText: $t('global.general.on'),
    offText: $t('global.general.off'),
    disabled: false,
    status: false
}


export default Toggle;
